import { obterConfig } from './configSistema';
import { carregarGoogleMaps } from './googleMaps';

// Geocodificação do endereço (o legado usava a API do Google com a chave exposta no
// JavaScript da página). OpenStreetMap/Nominatim: sem chave. Tenta do mais preciso ao
// mais genérico (endereço+número → rua → CEP → bairro → cidade) e devolve o primeiro
// que achar; o Nominatim pede no máximo 1 consulta por segundo, por isso o intervalo.
async function consultarNominatim(consulta) {
  try {
    const r = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=br&q=${encodeURIComponent(consulta)}`);
    if (!r.ok) return null;
    const achados = await r.json();
    return achados[0] ? { lat: achados[0].lat, lng: achados[0].lon } : null;
  } catch {
    return null;
  }
}

const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Com o mapa do Google ativo (Configurações), usa o Geocoder dele (sem o intervalo de 1 s do Nominatim);
// se falhar/recusar, segue com o Nominatim.
async function consultarGoogle(consulta, chave) {
  try {
    const maps = await carregarGoogleMaps(chave);
    const r = await new maps.Geocoder().geocode({ address: consulta, region: 'br' });
    const loc = r.results?.[0]?.geometry?.location;
    return loc ? { lat: String(loc.lat()), lng: String(loc.lng()) } : null;
  } catch {
    return null;
  }
}

export async function geocodificar({ endereco, numero, bairro, cidade, estado, cep }) {
  const cfg = (await obterConfig()).mapa;
  const usaGoogle = cfg.tipo === 'google' && !!cfg.google_key;
  const local = [cidade, estado].filter(Boolean).join(', ');
  const tentativas = [
    endereco && [`${endereco}${numero ? ` ${numero}` : ''}`, bairro, local].filter(Boolean).join(', '),
    endereco && numero && [endereco, local].join(', '),
    cep && `${cep}, Brasil`,
    bairro && local && `${bairro}, ${local}`,
    local,
  ].filter(Boolean);
  const feitas = new Set();
  for (const consulta of tentativas) {
    if (feitas.has(consulta)) continue;
    if (feitas.size > 0 && !usaGoogle) await esperar(1100);
    feitas.add(consulta);
    const achado = (usaGoogle && (await consultarGoogle(consulta, cfg.google_key))) || (await consultarNominatim(consulta));
    if (achado) return achado;
  }
  return null;
}
